import * as React from 'react';
import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import noDataImage from 'assets/images/noTreeData.png';

export const Wrapper = styled.div`
	height: 100%;
	padding: 2px;
	position: relative;
	overflow: auto;
`;

export const NoDataMessageWrapper = styled.div`
	background-image: url(${noDataImage});
	background-repeat: no-repeat;
	background-position: center 0;
	height: 350px;
	padding: 0 8px;
	display: flex;
	flex-direction: column;
	position: absolute;
	top: calc(50% - 180px);
	right: 0;
	left: 0;
	bottom: 0;
	background-size: 350px;
`;

export const NoDataMessageTitle = styled.div`
	margin-top: 240px;
	color: ${colors.grey8};
	font-size: 23px;
	font-style: normal;
	font-weight: 500;
	line-height: 31px;
	letter-spacing: 0.3px;
	text-align: center;
`;

export const NoDataMessageText = styled.div`
	color: ${colors.grey5};
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0.3px;
	text-align: center;
	height: 64px;
	margin: 48px auto 0;
	width: 310px;
`;

export const NoDataMessage = () => (
	<NoDataMessageWrapper>
		<NoDataMessageTitle>Create and map taxonomy</NoDataMessageTitle>
		<NoDataMessageText>
			Drag taxonomy items into the green area to build a new category structure,
			or create a new taxonomy from scratch
		</NoDataMessageText>
	</NoDataMessageWrapper>
);
